var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctorManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9995 13.5C20.899 13.5 23.2495 11.1495 23.2495 8.25C23.2495 5.35051 20.899 3 17.9995 3C15.1 3 12.7495 5.35051 12.7495 8.25C12.7495 11.1495 15.1 13.5 17.9995 13.5Z",
    stroke: "#548170",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99902 30.75C2.99902 24.1223 9.04327 18.75 16.499 18.75",
    stroke: "#548170",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.499 32.25C29.2269 32.25 32.249 29.2279 32.249 25.5C32.249 21.7721 29.2269 18.75 25.499 18.75C21.7711 18.75 18.749 21.7721 18.749 25.5C18.749 29.2279 21.7711 32.25 25.499 32.25Z",
    stroke: "#548170",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7485 23.25V26.25H27.7485",
    stroke: "#548170",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorManagementIcon);
export default __webpack_public_path__ + "static/media/DoctorManagement_Icon.9e959b0f16582b195f3980e97587433d.svg";
export { ForwardRef as ReactComponent };